import { useMemo } from "react";
import { useAuth } from "../../../context/AuthContext";
import {
  getRolePerformancePermissions,
  PERFORMANCE_PERMISSIONS,
} from "../constants/performancePermissions";

const usePerformancePermissions = () => {
  const { user } = useAuth();

  const role = user?.role;

  const permissions = useMemo(
    () => getRolePerformancePermissions(role),
    [role],
  );

  const can = (permission) => permissions.includes(permission);

  return {
    role,
    permissions,
    can,
    PERFORMANCE_PERMISSIONS,
  };
};

export default usePerformancePermissions;
